import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({html: true})

// https://github.com/markdown-it/markdown-it/blob/master/docs/architecture.md#renderer
var defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options)
}

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  // If you are sure other plugins can't add `target` - drop check below
  var aIndex = tokens[idx].attrIndex('target')

  if (aIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']) // add new attribute
  } else {
    tokens[idx].attrs[aIndex][1] = '_blank' // replace value of existing attr
  }

  // pass token to default renderer.
  return defaultRender(tokens, idx, options, env, self)
}

export default {
  install (Vue) {
    Vue.directive('markdown', (el, binding) => {
      const html = binding.value ? md.renderInline(binding.value) : ''
      el.innerHTML = html
    })
  }
}
